import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';
import { toQueryString } from 'utils/UrlUtil';

import {
    FETCH_GOLF_COURSE_STATS,
    FETCH_GOLF_COURSE_STATS_SUCCESS,
    FETCH_GOLF_COURSE_STATS_FAIL
} from '../actions/golfCourseActions.js';

export function* fetchGolfCourseStatsSaga(action) {
    try {
        const useSnapshotId = action.backNineCourseGlobalId || !action.courseGlobalId;
        const queryString = toQueryString({
            ...(useSnapshotId && { 'course-snapshot-id': action.courseSnapshotId }),
            ...(!useSnapshotId && { 'course-global-id': action.courseGlobalId }),
            ...(!useSnapshotId && { 'from-date': action.fromDate }),
            'image-size': 'IMG_730X730',
            'user-locale': action.userLocale
        });

        const response = yield call(golfApi.get, `/gcs-golfcommunity/api/v2/course-snapshot/stats${queryString}`);

        yield put({
            type: FETCH_GOLF_COURSE_STATS_SUCCESS,
            golfCourseStats: response.data || {},
            ...(action.fromDate && { fromDate: action.fromDate }),
            ...(action.courseSnapshotId && { courseSnapshotId: action.courseSnapshotId }),
            ...(action.courseGlobalId && { courseGlobalId: action.courseGlobalId })
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_COURSE_STATS_FAIL,
            golfCourseStats: {},
            ...(action.fromDate && { fromDate: action.fromDate }),
            ...(action.courseSnapshotId && { courseSnapshotId: action.courseSnapshotId }),
            ...(action.courseGlobalId && { courseGlobalId: action.courseGlobalId })
        });
    }
}

export const golfCourseStats = [takeEvery(FETCH_GOLF_COURSE_STATS, fetchGolfCourseStatsSaga)];
